<template>
  <div class="pt-[80px] xl:pt-[160px] h-full">
    <SectionContactsHero />
    <SectionContactForm />
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3573.1027573861525!2d55.25583209693893!3d25.188150144523284!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3e301ab7a79b17%3A0xaa7486766d9188c0!2ssaraf%20screening!5e0!3m2!1sru!2s!4v1747639790010!5m2!1sru!2s"
      width="100%"
      height="450"
      style="border: 0"
      allowfullscreen="true"
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
</template>

<script setup lang="ts">
import SectionContactsHero from "@/modules/Landing/components/Section/ContactsHero.vue";
import SectionContactForm from "@/modules/Landing/components/Section/ContactForm.vue";
import { useHead } from "@vueuse/head";

useHead({
  title: "Contact us | Saraf Robot",
  meta: [
    {
      name: "description",
      content:
        "We are here to help you get the most out of your automated trading experience with Saraf Robot. Whether you have questions, need assistance with setup, or want to learn more about how our platform can enhance your cryptocurrency trading, our team is always ready to support you.",
    },

    // Open Graph (OG) meta tags
    { property: "og:title", content: "Contact us | Saraf Robot" },
    {
      property: "og:description",
      content:
        "We are here to help you get the most out of your automated trading experience with Saraf Robot. Whether you have questions, need assistance with setup, or want to learn more about how our platform can enhance your cryptocurrency trading, our team is always ready to support you.",
    },
    { property: "og:image", content: "/og-image.webp" },
    { property: "og:image:height", content: "630" },
    { property: "og:image:width", content: "1200" },

    // Twitter meta tags
    { name: "twitter:card", content: "summary" },
    { name: "twitter:site", content: "@sarafrobot" },
    { name: "twitter:image", content: "/og-image.webp" },
  ],
  link: [{ rel: "canonical", href: "https://app.sarafrobot.com/contact-us" }],
});
</script>

<style scoped></style>
